import { FC } from 'react';
import { useUserRole } from '@/hooks/use-user-role';
import { OrganisationDevicesPage } from './organisation-devices-page';
import { PlatformDevicesPage } from './platform-devices-page';

export const DevicesPage: FC = () => {
  const { isPlatformAdmin } = useUserRole();
  return isPlatformAdmin ? (
    <PlatformDevicesPage />
  ) : (
    <OrganisationDevicesPage />
  );
};
